import module from '../module';
import * as _ from 'lodash';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';
import EditAddressController from '../controllers/EditAddressController';
import {utils} from "../../../utils/shopifyInjector/utils";

class UserProfileDirectiveController {
    static $inject = ['$scope', 'AuthenticationService', '$state', 'UserProfile', '$mdDialog',
        'Message', '$rootScope', 'cartonomyConfig', 'SessionStorage', 'Session','CartService','LocalForageService', '$translate'];

    constructor(scope, authenticationService, stateService, userProfileService, dialogService,
                messageService, rootScope, cartonomyConfig, SessionStorage, sessionService, cartService, localForageService, $translate) {
        this._scope = scope;
        this._stateService = stateService;
        this._userProfileService = userProfileService;
        this._dialogService = dialogService;
        this._messageService = messageService;
        this._authenticationService = authenticationService;
        this._cartonomyConfig = cartonomyConfig;
        this._rootScope = rootScope;
        //this._sessionStorageService = SessionStorage;
        this._localForageService = localForageService;
        this._sessionService = sessionService;
        this._cartService = cartService;
        this._translateService = $translate;

        scope.emailEditMode = false;
        scope.addressEditMode = false;

        scope.data = {
            addresses: [],
            emails: []
        };

        scope.openIdProviders = authenticationService.getOpenIdProviders();

        scope.toggleEmailEditMode = () => scope.emailEditMode = !scope.emailEditMode;
        scope.toggleAddressEditMode = () => scope.addressEditMode = !scope.addressEditMode;
        scope.toggleNameEditMode = () => scope.nameEditMode = !scope.nameEditMode;
        
        scope.changePassword = () => authenticationService.showChangePasswordDialog();
        scope.canChangePassword = () => this._canChangePassword();
        scope.login = () => authenticationService.showLoginDialog();
        scope.logout = async () => this.logout();

        scope.canLoadAvatarFrom = (openIdProvider) => this._canLoadAvatarFrom(openIdProvider);
        scope.updateAvatarFromProvider = (provider) => this._updateAvatarFromProvider(provider);

        scope.canLinkAccount = (openIdProvider) => this._canLinkAccount(openIdProvider);
        scope.linkToProvider = async (openIdProvider) => this._linkAccountToProvider(openIdProvider);

        this.onOAuthResponseCallback = event => this.onOAuthResponse(event);
        window.addEventListener('message', this.onOAuthResponseCallback);

        scope.isStoreAdmin = () => this._rootScope.isStoreAdmin;
        scope.changeAvatar = () => this._changeAvatar(event);

        scope.goToGroupOrderReport = () => {
          this._stateService.go(Constants.RoutingStates.STORE_ADMIN);
        };

        scope.goToOpenCarts = () => {
            this._stateService.go(Constants.RoutingStates.OPEN_CARTS);
        };
        scope.createNewGroupOrder = () => {
            // 1. Clear Stealth mod if needed
            if (this._sessionService.getStealthUserMode()) {
                this._sessionService.setStealthUserMode(null);
                this._cartService.resetCart();
                this._rootScope.$broadcast(Constants.Events.ORDER_CANCELLED);
            }

            // 2. go to
            this._rootScope.$broadcast(Constants.Events.OPEN_SPLASH_SCREEN);
            this._stateService.go(Constants.RoutingStates.CART);
        };

        scope.addEmailInput = () => this._addEmailInput();
        scope.saveProfile = () => this._save();
    }

    async $onInit() {

    }

    async _save() {
        let isError = false;
        this._scope.profile.emails.forEach(item => {
            if (!isError && !Constants.EMAIL_REGEX.test(item.email)) {
                this._messageService.showErrorPopup("Incorrect email address");
                isError = true;
            }
        });
        if(isError) {
            return;
        }
        try {
            let user = await this._userProfileService.saveProfile({
                firstName: this._scope.profile.firstName,
                lastName: this._scope.profile.lastName,
                emails:  this._scope.profile.emails
            });
            this._messageService.showMessagePopup(this._translateService.instant('client.profile.success'));
            this._sessionService.setSessionDetails( {
                userEmail: user.email,
                userName: user.fullName,
                firstName: user.firstName,
                lastName: user.lastName,
                authToken: await this._sessionService.getAuthToken(),
                isInvite: await this._sessionService.isInvite()
            })
        } catch (error) {
            this._messageService.showErrorPopupForResponse(error);
        }


    }

    async logout() {
        await this._authenticationService.logout();
        this._rootScope.$broadcast(Constants.Events.USER_LOGGED_OUT);

        let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CART : Constants.RoutingStates.CATALOG;
        this._authenticationService.showLoginDialog('', 'login');
    }

    async _changeAvatar($event){
        if($event && $event.target.files && $event.target.files.length > 0){
            let file = $event.target.files[0];
            let upload = await this._userProfileService.uploadAvatar(file);
            if(upload.status === 200){
                this._scope.profile.avatar = upload.data.data.avatar;
                this._scope.profile.avatarCropped = upload.data.data.avatar;
                this._rootScope.$broadcast(Constants.RootEvents.USER_PROFILE_UPDATED);
                scopeUtils.apply(this._scope);
            }
        }
    }

    _canChangePassword() {
        return !this._scope.isGuest && this._scope.profile && !this._scope.profile.linkOAuthOnly;
    }

    _canLoadAvatarFrom(openIdProvider) {
        return this._scope.profile && this._scope.profile.linkedOAuth && _.some(this._scope.profile.linkedOAuth, p => p == openIdProvider);
    }

    _canLinkAccount(openIdProvider) {
        return this._scope.profile && this._scope.profile.linkedOAuth && !_.some(this._scope.profile.linkedOAuth, p => p == openIdProvider);
    }

    async _linkAccountToProvider(openIdProvider) {
        await this._localForageService.store(Constants.SessionStorage.LINKING_SOCIAL_ACCOUNT, true);
        await this._authenticationService.checkLoginToken();
        let externalLogin = this._authenticationService.externalLogin(openIdProvider);
        window.open(`${externalLogin}`, 'social_login_facebook');
    }

    _updateAvatarFromProvider(provider) {
        this._userProfileService.updateOpenIdAvatar(provider)
            .then(() => {
                this._rootScope.$broadcast(Constants.RootEvents.USER_PROFILE_UPDATED);
            }, (error) => {
                const message = this._messageService.getMessageFromErrorResponse(error) || 'Cannot update avatar';
                this._messageService.showErrorPopup(message);
            });
    }

    async onOAuthResponse(response) {
        if (response.data.eventType !== 'OAuthResult') {
            return;
        }

        if(!(await this._sessionService.loggedIn()))
        {
            return;
        }
        const responseData = response.data;

        const authToken = responseData.token;
        if (!authToken && responseData.errorMessage) {
            await this._messageService.showErrorPopup(responseData.errorMessage);
            return;
        }

        window.removeEventListener('message', this.onOAuthResponseCallback);
        try {
            await this._authenticationService.externalLoginFinalize(authToken);
        } catch (error) {
            await this._messageService.showErrorPopupForResponse(error);
            return;
        }

        await this._sessionService.clearSessionDetails();
        await this._sessionService.setSessionDetails({
            authToken: authToken,
            userEmail: await this._sessionService.getUserEmail(),
            userName: await this._sessionService.getUserName()
        });
        this._userProfileService.resetUser();
        const user = await this._userProfileService.getUser();

        await this._sessionService.setSessionDetails({
            authToken: authToken,
            userEmail: user.email,
            userName: user.fullName,
            firstName: user.firstName,
            lastName: user.lastName
        });


        let awaitingInvitation = null;
        if(utils.hash.indexOf('#/invite/') > -1){
            awaitingInvitation = JSON.stringify({participantToken : utils.hash.replace('#/invite/','') });
        }
        if (awaitingInvitation) {
            this._stateService.go(Constants.RoutingStates.INVITE, JSON.parse(awaitingInvitation));
            return;
        }

        let linkingSocialAccount = await this._localForageService.retrieve(Constants.SessionStorage.LINKING_SOCIAL_ACCOUNT);
        if (linkingSocialAccount) {
            await this._localForageService.remove(Constants.SessionStorage.LINKING_SOCIAL_ACCOUNT);
            this._stateService.go(Constants.RoutingStates.USER_PROFILE);
            return;
        }

        this._sessionService.setCartReference(null);
    }
}

module.directive('userProfile', function () {
    return {
        scope: true,
        template: require('../views/userProfile.pug'),
        controller: UserProfileDirectiveController
    };
});

module.directive('fileOnChange', function () {
    return {
        scope: true,
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.bind('change', scope.changeAvatar);
        },
        controller: UserProfileDirectiveController
    };
});



// WEBPACK FOOTER //
// ./src/modules/profile/directives/UserProfileDirective.js